import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 2,
	viewBox: "0 0 6 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0.962891H6.0008",
		stroke: "#99BCDF"
	})
});
export default SvgMinusIcon;
